import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchJobConfiguration, IKeepInTouchJobConfigurationRequest } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCreateKeepInTouchConfiguration = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchJobConfiguration) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IKeepInTouchJobConfigurationRequest) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchJobConfiguration>(
				'KeepInTouchJobConfiguration',
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
